module.exports = __webpack_public_path__ + "img/17.3e3c6a33.png";